<template>
  <Modal v-model="receivingAddressModal" :title="receivingAddressTitle"
    width="700" :transfer="false" :mask-closable="false" @on-visible-change="receivingAddressModalChange">
    <Form ref="receivingAddressForm" :model="receivingAddressForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001161')" prop="countryCode">
            <Select v-model="receivingAddressForm.countryCode" filterable transfer @on-change="changeInputValue">
              <Option v-for="(item, index) in countrysData" :key="index" :value="item.twoCode">{{ item.twoCodeName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001162')" prop="state">
            <Input :placeholder="$t('key1001163')" clearable v-model.trim="receivingAddressForm.state"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001164')" prop="city">
            <Input :placeholder="$t('key1001165')" clearable v-model.trim="receivingAddressForm.city"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001166')" prop="county">
            <Input :placeholder="$t('key1001167')" clearable v-model.trim="receivingAddressForm.county"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001168')" prop="streetAddress">
            <Input :placeholder="$t('key1001169')"
              v-model.trim="receivingAddressForm.streetAddress" clearable></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001170')" prop="postalCode">
            <Input :placeholder="$t('key1001171')" v-model.trim="receivingAddressForm.postalCode" clearable></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001172')" prop="name">
            <Input :placeholder="$t('key1001173')" v-model.trim="receivingAddressForm.name" clearable></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001174')" prop="mobile">
            <div class="flex align-items">
              <Select v-model="receivingAddressForm.mobileAreaCode" filterable transfer style="width: 160px; margin-right: 12px;">
                <Option v-for="(item, index) in countrysData" :value="item.areaCode"
                  :key="index">{{ item.areaCodeName }}</Option>
              </Select>
              <Input :placeholder="$t('key1001001')" clearable v-model.trim="receivingAddressForm.mobile" style="flex: 1;"></Input>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001175')" prop="phone">
            <div class="flex align-items">
              <Select v-model="receivingAddressForm.phoneAreaCode" filterable transfer style="width: 160px; margin-right: 12px;">
                <Option v-for="(item, index) in countrysData" :value="item.areaCode"
                  :key="index">{{ item.areaCodeName }}</Option>
              </Select>
              <Input :placeholder="$t('key1001176')" clearable v-model.trim="receivingAddressForm.phone" style="flex: 1;"></Input>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001177')" prop="email">
            <Input :placeholder="$t('key1001178')" clearable v-model.trim="receivingAddressForm.email"></Input>
          </Form-item>
        </Col>
        <Checkbox style="margin-left: 110px;" :disabled="defaultTalg" :true-value="1" :false-value="0" v-if="getPermission('ymsDeliveryAddress_updateStatus')"
          v-model="receivingAddressForm.isDefault">{{ $t('key1001179') }}
        </Checkbox>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: center;">
        <Button @click="receivingAddressModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="receivingAddressBtn">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllCountrysData} from "@/utils/common";

export default {
  name: "receivingAddressModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      receivingAddressModal: false,
      receivingAddressTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001152'),
      ruleValidate: {
        state: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001153'),
            trigger: 'blur'
          }
        ],
        city: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001154'),
            trigger: 'blur'
          }
        ],
        county: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001155'),
            trigger: 'blur'
          }
        ],
        streetAddress: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001156'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001157'),
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001158'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            validator: v.validateMailboxFormat(false),
            trigger: 'blur'
          }
        ]
      },
      receivingAddressForm: {
        countryCode: 'CN', // 国家
        county: '', // 区县
        state: '', // 省/州
        city: '', // 城市
        streetAddress: '', // 详细地址
        postalCode: '', // 邮政编码
        name: '', // 收货人姓名
        mobile: '', // 手机号码
        phone: '', // 固定电话
        email: '', // 邮箱地址
        mobileAreaCode: '86',  // 手机号码前缀
        phoneAreaCode: '86', // 固定电话的前缀
        isDefault: 0 // 设为默认地址
      },
      defaultTalg: false,
      countryList: [],
      addressStatus: 'add',
      countrysData: []
    };
  },
  methods: {
    // 弹窗确定按钮
    receivingAddressBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      if (v.addressStatus === 'add') {
        url = api.post_ymsDeliveryAddress;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001159');
      } else {
        url = api.put_ymsDeliveryAddress;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001160');
      }
      let query = JSON.parse(JSON.stringify(v.receivingAddressForm));
      query.mobile = '+' + v.receivingAddressForm.mobileAreaCode + ' ' + v.receivingAddressForm.mobile;
      query.phone = '+' + v.receivingAddressForm.phoneAreaCode + ' ' + v.receivingAddressForm.phone;
      v.$refs.receivingAddressForm.validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.receivingAddressModal = false;
              v.$Message.success(text);
              v.$emit('updateAddress');
            }
          });
        }
      });
    },
    // 选择国家地区
    changeInputValue(value) {
      this.receivingAddressForm.mobileAreaCode = '86';
      this.receivingAddressForm.phoneAreaCode = '86';
      this.countrysData.map((item) => {
        if (item.twoCode === value) {
          this.receivingAddressForm.mobileAreaCode = item.areaCode;
          this.receivingAddressForm.phoneAreaCode = item.areaCode;
        }
      });
    },
    // 监听弹窗
    receivingAddressModalChange(value) {
      if (value) {
        getAllCountrysData('en').then((data) => {
          this.countrysData = data;
        });
      } else {
        this.defaultTalg = false;
        this.$refs['receivingAddressForm'].resetFields();
        this.receivingAddressForm.mobileAreaCode = '86';
        this.receivingAddressForm.phoneAreaCode = '86';
      }
    }
  }
};
</script>

<style scoped>

</style>
